"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Database, Store, Code, Globe, Smartphone, Search, Server, ArrowRight } from "lucide-react";
const services = [{
  title: "Strategia Domini .RU",
  description: "Acquisizione e gestione di asset digitali nativi russi. Ottimizzazione DNS locale per garantire accessibilità totale e conformità normativa.",
  icon: Globe,
  badge: "Critico"
}, {
  title: "Localizzazione CDN",
  description: "Infrastruttura di distribuzione contenuti distribuita su nodi russi per abbattere la latenza e superare i filtri del RuNet.",
  icon: Server,
  badge: "Performance"
}, {
  title: "Ottimizzazione Velocità",
  description: "Fine-tuning tecnico per i protocolli di rete russi, garantendo tempi di caricamento istantanei su tutto il territorio della Federazione.",
  icon: Database,
  badge: ""
}, {
  title: "Conformità FZ-152",
  description: "Architetture database progettate per il rispetto della legge russa sulla localizzazione dei dati personali dei cittadini.",
  icon: Code,
  badge: ""
}, {
  title: "Mobile RuNet UX",
  description: "Sviluppo di interfacce ottimizzate per l'ecosistema mobile russo, integrate con i principali gateway di pagamento locali.",
  icon: Smartphone,
  badge: "Nuovo"
}, {
  title: "Audit Tecnico Yandex",
  description: "Analisi profonda dei parametri di scansione YandexBot per eliminare colli di bottiglia strutturali e migliorare il crawling.",
  icon: Search,
  badge: ""
}, {
  title: "Cyber-Security CSI",
  description: "Protezione avanzata contro minacce specifiche dell'area CSI e sistemi di monitoraggio attivi 24/7 sui nodi strategici.",
  icon: Store,
  badge: ""
}];
export default function ExpertItServices() {
  const headerReveal = useRevealOnScroll({
    threshold: 0.1
  });
  const gridReveal = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="235057" id="architetture-web-native-e-domini-ru" className="relative bg-background text-foreground py-24 overflow-hidden">
      {}
      <div className="absolute inset-0 bg-secondary/5 pointer-events-none" aria-hidden="true" />
      
      {}
      <div className="absolute inset-0 opacity-[0.05] pointer-events-none" style={{
      backgroundImage: 'radial-gradient(circle at 2px 2px, #00E5FF 1px, transparent 0)',
      backgroundSize: '48px 48px'
    }} aria-hidden="true" />

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div ref={headerReveal.ref} className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-700 ${headerReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Badge variant="outline" className="mb-4 border-primary/40 bg-primary/5 text-primary hover:bg-primary/20 font-mono">
            [INFRASTRUCTURE_LAYER]
          </Badge>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default text-foreground mb-6 tracking-tighter uppercase">
            Architetture Web Native e Domini .RU
          </h2>
          <p className="text-lg text-muted-foreground font-default">
            Sviluppiamo ecosistemi digitali progettati per la sovranità tecnologica russa. Prestazioni estreme, conformità legale e resilienza infrastrutturale.
          </p>
        </div>

        <div ref={gridReveal.ref} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 xl:gap-8 transition-all duration-1000 delay-200 ${gridReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {services.map((service, i) => {
          const Icon = service.icon;
          return <div data-index={i} key={i} className="h-full">
                <Card className="group h-full border-t-2 border-t-primary border-x-border/30 border-b-border/30 bg-card/40 backdrop-blur-md hover:border-secondary hover:shadow-2xl hover:shadow-secondary/20 hover:-translate-y-1 transition-all duration-500 flex flex-col">
                  <CardHeader className="pb-4">
                    <div className="flex justify-between items-start mb-4">
                      <div className="p-3 rounded-sm bg-secondary/10 text-secondary group-hover:bg-secondary group-hover:text-secondary-foreground transition-colors duration-300">
                        <Icon className="w-6 h-6" />
                      </div>
                      {service.badge && <Badge variant={service.badge === 'Critico' ? 'destructive' : 'secondary'} className="shadow-sm font-mono text-[10px] uppercase tracking-widest">
                          {service.badge}
                        </Badge>}
                    </div>
                    <CardTitle className="text-xl font-bold font-default text-foreground group-hover:text-secondary transition-colors">
                      {service.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="flex-grow">
                    <p className="text-muted-foreground leading-relaxed font-default text-sm">
                      {service.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>

        <div className="mt-16 text-center">
          <Button asChild size="lg" className="rounded-none px-10 bg-primary text-primary-foreground font-bold uppercase tracking-widest shadow-lg shadow-primary/20 hover:shadow-secondary/40 hover:bg-secondary hover:text-secondary-foreground transition-all duration-300 group">
            <Link to="/ContactPage">
              Richiedi Analisi Infrastruttura
              <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}